/* eslint-disable no-console */
/* eslint-disable global-require */
/* eslint-disable no-param-reassign */

interface NoticeErrorProps {
  err: unknown
  customAttributes?: Record<string, any>
}

export const noticeError = ({ err, customAttributes = {} }: NoticeErrorProps) => {
  if (typeof window === 'undefined') {
    try {
      const newrelic = require('newrelic')
      if (typeof err === 'string') {
        err = new Error(err)
      }
      newrelic.noticeError(err, customAttributes)
    } catch (err) {
      console.error('Newrelic notice error failed', err)
    }
  }
}
